import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticatedApi } from './api';
import { toast } from 'react-hot-toast';

export default function Welcome() {
  const navigate = useNavigate();
  const { authenticatedFetch } = useAuthenticatedApi();
  const [referralSource, setReferralSource] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await authenticatedFetch(
        `${process.env.REACT_APP_API_URL || '/api'}/members/referral-source`,
        {
          method: 'POST',
          body: JSON.stringify({ referral_source: referralSource.trim() || null })
        }
      );
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || 'Failed to save');
      }
      toast.success('Thanks for letting us know!');
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(err.message || 'Something went wrong. You can skip for now.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = () => {
    navigate('/', { replace: true });
  };

  return (
    <div
      style={{
        padding: '3rem 2rem',
        maxWidth: '480px',
        margin: '0 auto',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <h1
        style={{
          fontSize: '1.75rem',
          fontWeight: '700',
          color: '#333',
          marginBottom: '0.5rem',
          textAlign: 'center'
        }}
      >
        Welcome to Study Hall
      </h1>
      <p
        style={{
          fontSize: '1rem',
          color: '#666',
          marginBottom: '1.5rem',
          textAlign: 'center',
          lineHeight: '1.5'
        }}
      >
        One quick question before you get started:
      </p>
      <form onSubmit={handleSubmit}>
        <label
          htmlFor="referral-source"
          style={{
            display: 'block',
            fontSize: '0.9375rem',
            fontWeight: '600',
            color: '#333',
            marginBottom: '0.5rem'
          }}
        >
          How did you hear about us?
        </label>
        <textarea
          id="referral-source"
          value={referralSource}
          onChange={(e) => setReferralSource(e.target.value)}
          placeholder="e.g. a friend, social media, a newsletter..."
          rows={4}
          maxLength={2000}
          style={{
            width: '100%',
            padding: '12px 14px',
            border: '2px solid #e9ecef',
            borderRadius: '6px',
            fontSize: '1rem',
            lineHeight: '1.5',
            resize: 'vertical',
            boxSizing: 'border-box',
            marginBottom: '1rem'
          }}
        />
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              flex: '1',
              minWidth: '120px',
              backgroundColor: isSubmitting ? '#ccc' : '#38b44a',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
          >
            {isSubmitting ? 'Saving...' : 'Submit'}
          </button>
          <button
            type="button"
            onClick={handleSkip}
            disabled={isSubmitting}
            style={{
              padding: '12px 20px',
              backgroundColor: 'transparent',
              color: '#666',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '1rem',
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
          >
            Skip
          </button>
        </div>
      </form>
    </div>
  );
}
